/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

EDC.Games.IdentifyTheSeason.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.IdentifyTheSeason, 47]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.IdentifyTheSeason.GameData;
  this.difficulty = 1;
  this.season = [];
  this.choices = [];
  this.window = null;
};

EDC.Games.IdentifyTheSeason.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.IdentifyTheSeason.Scenes.Main.prototype.constructor = EDC.Games.IdentifyTheSeason.Scenes.Main;

const ITS = EDC.Games.IdentifyTheSeason.Scenes.Main.prototype;

ITS.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

ITS.createTemplateUI = function () {
  this.add.sprite(1000, 120, 'title');
  this.add.sprite(720, 960, 'question').setScale(1.02);
  this.window = this.add.sprite(630, 515, 'window').setDepth(1);
  this.add.sprite(1805, 660, 'dog').setScale(0.75);
};

ITS.loadIteration = function () {
  this.addChoices();
  this.createSeason();
};

ITS.addChoices = function () {
  for (let i = 0; i < 4; i++) {
    const { x, y, text } = this.getChoicePosition(i);
    const choiceContainer = this.add.container(x, y);
    const button = this.add.sprite(0, 0, 'button').setScale(0.5);
    const textOnButton = this.add.sprite(0, 0, text).setScale(0.25);
    choiceContainer.add(button);
    choiceContainer.add(textOnButton);
    choiceContainer.seasonText = text.substring(0, text.length - 4);
    choiceContainer.setSize(430, 110);
    choiceContainer.setInteractive();
    const markAnim = new AnswerMark(this, choiceContainer).setScale(0.25);
    choiceContainer.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(choiceContainer);
    choiceContainer.on('pointerup', this.checkAnswer.bind(this, choiceContainer), this);
    this.choices.push(choiceContainer);
  }
};

ITS.getChoicePosition = function (i) {
  const x = 1300;
  const y = 300 + i * 130;
  const seasonText = {
    0: 'summerText',
    1: 'springText',
    2: 'winterText',
    3: 'autumnText',
  };
  const text = seasonText[i];
  return { x, y, text };
};

ITS.createSeason = function () {
  // eslint-disable-next-line object-curly-newline
  const { season, hint, seasonX, seasonY, hintX, hintY } = this.getSeasonPosition();
  if (this.difficulty === 1) {
    const seasonSprite = this.add.sprite(seasonX, seasonY, season);
    const hintSprite = this.add.sprite(hintX, hintY, hint);
    this.season.push(seasonSprite);
    this.season.push(hintSprite);
  } else if (this.difficulty === 2) {
    const seasonSprite = this.add.sprite(seasonX, seasonY, season);
    this.season.push(seasonSprite);
  }
};

ITS.getSeasonPosition = function () {
  let season;
  let hint;
  let hintX;
  let hintY;
  const { correctAnswer } = this.gameConfig.sets[this.difficulty];
  const seasonX = 640;
  const seasonY = 500;
  hintX = 1660;
  hintY = 730;
  if (correctAnswer === 'winter') {
    hintY = 640;
    hintX = 1760;
  }
  if (correctAnswer === 'summer') {
    hintY = 600;
    hintX = 1750;
  }
  if (correctAnswer === 'spring') {
    hintY = 555;
    hintX = 1775;
  }
  const seasons = {
    autumn: { season: 'autumn', hint: 'autumnHint' },
    spring: { season: 'spring', hint: 'springHint' },
    summer: { season: 'summer', hint: 'summerHint' },
    winter: { season: 'winter', hint: 'winterHint' },
  };
  // eslint-disable-next-line prefer-const
  season = seasons[correctAnswer].season;
  // eslint-disable-next-line prefer-const
  hint = seasons[correctAnswer].hint;
  return {
    seasonX,
    seasonY,
    hintX,
    hintY,
    season,
    hint,
  };
};

ITS.checkAnswer = function (answer) {
  const { correctAnswer } = this.gameConfig.sets[this.difficulty];
  if (answer.seasonText === correctAnswer) {
    this.playCorrect();
    this.choices.map((x) => {
      x.disableInteractive();
      return true;
    });
    answer.getData('markAnim').showMark(true, () => {});
    this.time.delayedCall(2000, this.changeLevel, [], this);
  } else {
    answer.disableInteractive();
    this.playWrong();
    answer.first.setTint(0xff0000);
    answer.last.setTint(0xff6347);
    answer.getData('markAnim').showMark(false, () => {});
    this.shakeAnimation(answer);
  }
};

ITS.changeLevel = function () {
  if (this.difficulty === 2) {
    this.showSummary();
    this.window.setDepth(0);
  } else {
    this.difficulty = this.difficulty + 1;
    this.season.map((x) => {
      x.destroy();
      return true;
    });
    this.season = [];
    this.choices.map((x) => {
      x.destroy();
      return true;
    });
    this.choices = [];
    this.loadIteration();
  }
};

ITS.shakeAnimation = function (answer) {
  answer.x += 10;
  this.tweens.add({
    targets: answer,
    x: answer.x - 10,
    duration: 30,
    ease: 'Linear',
    repeat: 3,
    yoyo: true,
    onComplete: this.returnToInitPos,
    onCompleteParams: [answer],
  });
};

ITS.returnToInitPos = function (tween, targets, answer) {
  answer.x = 1300;
};
export default EDC.Games.IdentifyTheSeason.Scenes.Main;
